import { useEffect, useState } from "react"
import { Formik, Form } from "formik"
import * as inputsForm from "../Form"

export function EditInPlace({ children, name, onUpdate, originalValue, fieldType = 'Textbox' }) {
	const EditField = inputsForm[fieldType]

	const [emEdicao, setEmEdicao] = useState(false)

	function handleUpdate(values) {
		onUpdate(values)
		
		setEmEdicao(false)
	}

	function getEvent(submitForm) {
		return fieldType === 'Calendar' ? {
			onChange: () => {
				submitForm()
			}
		} : {
			onBlur: () => {
				submitForm()
			}
		}
	}

	// Only for Calendar component
	useEffect(() => {
		if(fieldType !== 'Calendar') {
			return
		}

		function handleClick(e) {
			const isEditArea = e.target.closest('.edit-in-place') || e.target.closest('.p-datepicker')

			if(isEditArea) {
				return
			}

			if(emEdicao) {
				const deveFecharCalendario = !e.target.classList.contains('p-inputtext')

				if(deveFecharCalendario) {
					setEmEdicao(false)
				}
			}
		}

		document.body.addEventListener('click', handleClick)

		return () => {
			document.body.removeEventListener('click', handleClick)
		}
	}, [fieldType, emEdicao])

	if(emEdicao) {
		return (
			<Formik onSubmit={handleUpdate} initialValues={{ [name]: originalValue }}>
				{({ submitForm }) => (
					<Form className="w-full">
						<EditField 
							name={name} 
							label="" 
							containerClass="w-full" 
							disableSubmitWithEnter={false} 
							focused={'true'}
							{...getEvent(submitForm)}
						/>
					</Form>
				)}
			</Formik>
		)
	}

	return (
		<div onClick={() => { setEmEdicao(true) }}>
			{children({ emEdicao, setEmEdicao })}
		</div>
	)
}